import API from 'store/v2/api'
import Model from '../models'
import { getLocalCartId } from 'shared/utils/cart'

Model.Cart.createAction('FETCH', (params) => {
  if (params == null) {
    params = {}
  }

  const cartId = getLocalCartId()
  const provider = window.booqableOptions.storeProvider
  const pathName = document.location.pathname

  if (provider) {
    params.provider = provider
  }

  if (pathName.startsWith('/preview') || pathName.startsWith('/shop/preview')) {
    params.previewing = true
  }

  if (cartId !== 'null') {
    params.id = cartId
  }

  return API.get('cart', { ...params, apiVersion: 1 })
})

Model.Cart.createAction('UPDATE', (params) => {
  if (params == null) {
    params = {}
  }

  params.id = getLocalCartId()

  return API.put('cart', { ...params, apiVersion: 1 })
})

Model.Cart.createAction('BOOK', (params) => {
  if (params == null) {
    params = {}
  }

  params.id = getLocalCartId()

  return API.createResource('cart/book', { ...params, apiVersion: 1 })
})

Model.Cart.createAction('CLEAR', () => {
  const params = {
    id: getLocalCartId()
  }

  return API.createResource('cart/clear', { ...params, apiVersion: 1 })
})

export default Model.Cart.actions
